export default ({ store }, inject) => {
  const GTMService = {
    baseUrl: "/gtm",
    previewHeader: process.env.NUXT_ENV_GTM_PREVIEW_HEADER,

    getClientId() {
      // Get accountId from store
      const accountId = store.state?.account?.user?.accountId;
      if (accountId) {
        return accountId;
      }

      // Fallback to localStorage for non-logged in users
      let cid = localStorage.getItem("_gtm_client_id");
      if (!cid) {
        cid = `guest_${Math.random()}_${Date.now()}`; // Using default for guest
        localStorage.setItem("_gtm_client_id", cid);
      }
      return cid;
    },

    async sendEvent(eventName, params = {}) {
      const queryParams = new URLSearchParams({
        v: "2",
        en: eventName,
        tid: process.env.NUXT_ENV_GA4_MEASUREMENT_ID,
        cid: this.getClientId(),
        dl: window.location.href,
        ...params,
      });

      try {
        const response = await fetch(
          `${this.baseUrl}/g/collect?${queryParams}`,
          {
            method: "GET",
            headers: {
              "x-gtm-server-preview": this.previewHeader,
            },
          }
        );

        return response.ok;
      } catch (error) {
        console.error("GTM service error:", error);
        return false;
      }
    },
  };

  inject("gtmService", GTMService);
};
